module.exports = __webpack_public_path__ + "img/link02_sp.d0e4d97d.png";